import { useContext } from "react";
import {
  AmeaInfrastructureContext,
  AmeaRoutesDataContext,
  EnvironmentalDataContext,
  MeteoInfoDataContext,
  WeatherDataContext,
  IndexesDataContext,
  AllSensorsDataContext,
  AmeaInfrastructureFiltersContext,
  SensorTypesDataContext,
  NewRouteContext,
  UserAuthContext,
  AmeaDataContext,
  AmeaRoutesCategoriesContext,
  BinsDataContext,
  HotSpotsDataContext,
  FleetDataContext,
  HydroDataContext,
  HumDataContext,
  EnergyDataContext,
  ParkingDataContext,
  VariablesContext,
} from "./context";

export const useAllContexts = () => {
  const ameaInfrastructures = useContext(AmeaInfrastructureContext);
  const ameaRoutes = useContext(AmeaRoutesDataContext);
  const ameaFilters = useContext(AmeaInfrastructureFiltersContext);
  const ameaData = useContext(AmeaDataContext);
  const environment = useContext(EnvironmentalDataContext);
  const meteo = useContext(MeteoInfoDataContext);
  const weather = useContext(WeatherDataContext);
  const indexes = useContext(IndexesDataContext);
  const allSensors = useContext(AllSensorsDataContext);
  const sensorTypes = useContext(SensorTypesDataContext);
  const newRouteData = useContext(NewRouteContext);
  const auth = useContext(UserAuthContext);
  const ameaRoutesCategories = useContext(AmeaRoutesCategoriesContext);
  const bins = useContext(BinsDataContext);
  const hotSpots = useContext(HotSpotsDataContext);
  const fleet = useContext(FleetDataContext);
  const hydro = useContext(HydroDataContext);
  const hum = useContext(HumDataContext);
  const energy = useContext(EnergyDataContext);
  const parking = useContext(ParkingDataContext);
  const variables = useContext(VariablesContext);

  return {
    ameaInfrastructures,
    ameaRoutes,
    ameaFilters,
    ameaData,
    environment,
    meteo,
    weather,
    indexes,
    allSensors,
    sensorTypes,
    newRouteData,
    auth,
    ameaRoutesCategories,
    bins,
    hotSpots,
    fleet,
    hydro,
    hum,
    energy,
    parking,
    variables,
  };
};
